import { usePersonalizedContent } from './usePersonalizedContent';
import { useIsPersonalizedContentEnabled } from './usePersonalizedParams';
export const usePersonalizedTitle = () => {
  var _data$title;
  const isEnabled = useIsPersonalizedContentEnabled();
  const {
    data,
    enabled,
    isLoading
  } = usePersonalizedContent();
  return {
    translation: isEnabled ? data == null || (_data$title = data.title) == null ? void 0 : _data$title.translation : undefined,
    isLoading: enabled && isLoading,
    isEnabled
  };
};
//# sourceMappingURL=usePersonalizedTitle.js.map